export const environment = {
  production: false,
  test: false,
  dev: true,
  environmentURL: "aHR0cHM6Ly9hcGktZGV2Lm54dHNvZnQuY29tL3Yy",
  packageVERSION: "Mi4xMC4w",
}
